import{jsxs as e,jsx as t}from"react/jsx-runtime";import{useState as r,useEffect as o}from"react";import a from"tailwind-styled-components";import{Check as n}from"lucide-react";import i from"clsx";import l from"../animate/animate.js";const c=a.div`
  bg-white
  border
  border-black/20
  inline-flex
  items-center
  justify-center
  relative
  rounded
  text-xs
  transition-all
  duration-75

  hover:shadow
  dark:bg-gray-700
`,m=a.input`
  absolute
  appearance-none
  cursor-pointer
  h-full
  w-full
  top-0
  left-0
  opacity-0
`,s=({className:a,checked:s,onChange:d,size:p="normal",...h})=>{const[u,f]=r(!!s),b=i(a,{"w-4 h-4":"small"===p,"w-5 h-5":"normal"===p,"w-6 h-6":"large"===p,"w-7 h-7":"xlarge"===p,"bg-brand-primary dark:bg-brand-primary text-white":u});return o((()=>{f(!!s)}),[s]),e(c,{className:b,children:[t(l,{animationIn:"zoomIn",animationOut:"zoomOut",duration:150,visible:u,children:t(n,{})}),t(m,{...h,className:"text-white",onChange:e=>{const t=e.target.checked;"boolean"!=typeof s&&f(t),"function"==typeof d&&d(t)},role:"checkbox",type:"checkbox"})]})};export{s as default};
